import robuxModule from "../robuxModule";

function robuxContainerBase(premiumConstants) {
    "ngInject";

    return {
        restrict: "A",
        scope: false,
        templateUrl: premiumConstants.templates.robuxContainerBase,
        link: function (scope, elem, attr) {
            scope.isStarcodeMobileEnabled = attr.isStarcodeMobileEnabled === 'true';
        }
    }
}


robuxModule
    .directive("robuxContainerBase", robuxContainerBase);

export default robuxModule;